import { useId } from 'react'
import cx from 'classnames'

import { Input } from './Input'

export const CheckboxField = ({ checked, disabled, helper, id, label, onChange, ...props }) => {
  const generatedId = useId()
  const inputId = id || generatedId
  const labelId = `${inputId}-label`
  const helperId = `${inputId}-helper`

  return (
    <label
      className={cx(
        'ds-checkbox-field tw:flex tw:items-start tw:gap-3 tw:py-2',
        disabled ? 'tw:cursor-not-allowed' : 'tw:cursor-pointer',
      )}
      data-disabled={disabled || undefined}
      htmlFor={inputId}
    >
      <span className="ds-checkbox-control">
        <Input aria-describedby={helper ? helperId : undefined} aria-labelledby={labelId} checked={checked} disabled={disabled} id={inputId} onChange={onChange} type="checkbox" {...props} />
      </span>
      <span className="tw:grid tw:gap-1">
        <span className="tw:text-base tw:text-foreground" id={labelId}>{label}</span>
        {helper && <span className="ds-helper" id={helperId}>{helper}</span>}
      </span>
    </label>
  )
}
